<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <filter-incomes
          :default-search-params="searchParams"
          :is-component-loading="isRequestingNow"
          @filtering="onFilter"
          @download-excel="onDownloadExcel"
          v-if="isTopManager"
        ></filter-incomes>
        <table-paginated-incomes
          :is-component-loading="isRequestingNow"
          :paginated-object="paginatedObject"
          :result="result"
          :allTotals="allTotals"
        ></table-paginated-incomes>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';
/* constants */
import { DATE_ISO } from '@/constants/dates';
/* proxy */
import IncomesProxy from '@/proxies/Cashier/IncomesProxy';
/* mixins */
import accountMixin from '@/mixins/accountMixin';
import defaultListingMixin from '@/mixins/listing/defaultListingMixin';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import downloadReport from '@/mixins/reports/downloadReport';
import incomeListing from '@/mixins/cashier/incomeListing';
/* components */
import TablePaginatedIncomes from '@/components/listings/TablePaginatedIncomes.vue';
import FilterIncomes from '@/components/listings/FilterIncomes.vue';


export default {
  name: 'Incomes',
  mixins: [
    accountMixin,
    updatePageContentMixin,
    defaultListingMixin,
    downloadReport,
    incomeListing,
  ],
  components: {
    TablePaginatedIncomes,
    FilterIncomes,
  },
  data() {
    return {
      reportMethodName: 'incomeListingReport',
      searchParams: {
        from: null,
        to: null,
      },
      paginatedObject: {},
      result: 0.00,
      allTotals: {},
    };
  },
  created() {
    this.searchParams.order_to = 'desc';
    this.searchParams.from = moment()
      .startOf('day')
      .format(DATE_ISO);
  },
  methods: {
    fetchData() {
      this.isRequestingNow = true;
      new IncomesProxy()
        .setParameters(this.searchParams)
        .all()
        .then((response) => {
          this.paginatedObject = response.data.data.incomes;
          this.result = response.data.data.total;
          this.allTotals = response.data.data.allTotals;
          this.$forceUpdate();
          console.log(response.data.data);
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
          this.result = null;
          this.allTotals = null;
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
  },
};
</script>
